import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'
import { DownloadFile } from '@/core/utils'
import AssinarEletronicamenteDocPedidoLoteInput from '@/core/apiclient/processo-digital/models/AssinarEletronicamenteDocPedidoLoteInput'

export default {
	async [actionTypes.PEDIDO.DOCUMENTOS.PROCESSO_DIGITAL.VISUALIZAR_PROCESSO_DIGITAL](context, idPedido) {
		const { data } = await api.documentoPedidoProcessoDigital.buscarProcessoDigitalUrl(idPedido)
		return data
	},

	async [actionTypes.PEDIDO.DOCUMENTOS.PROCESSO_DIGITAL.JUNTAR_LOTE_DOCUMENTOS](context, payload) {
		const { data } = await api.documentoPedidoProcessoDigital.juntarLoteDocumentosProcessoDigital(payload)
		return data
	},
	async [actionTypes.PEDIDO.DOCUMENTOS.PROCESSO_DIGITAL.BAIXAR_PARA_IMPRESSAO](context, idDocumento) {
		const response = await api.documentoPedidoProcessoDigital.baixarDocumentoProcessoDigital(idDocumento)
		DownloadFile.downloadArrayBufferPdf(response.data, response.headers.filename)
	},
	async [actionTypes.PEDIDO.DOCUMENTOS.PROCESSO_DIGITAL.ASSINAR_ELETRONICAMENTE](context, idDocumento) {
		return await api.documentoPedidoProcessoDigital.assinarEletronicamenteDocumentoProcessoDigital(idDocumento)
	},
	async [actionTypes.PEDIDO.DOCUMENTOS.PROCESSO_DIGITAL.ASSINAR_ELETRONICAMENTE_LOTE](
		context,
		{ idPedido, idsDocumentosPedido },
	) {
		return await api.documentoPedidoProcessoDigital.assinarEletronicamenteLoteDocumentoProcessoDigital(
			idPedido,
			new AssinarEletronicamenteDocPedidoLoteInput(idPedido, idsDocumentosPedido),
		)
	},
	async [actionTypes.PEDIDO.DOCUMENTOS.PROCESSO_DIGITAL.ASSINAR_DIGITALMENTE](context, idDocumento) {
		return await api.documentoPedidoProcessoDigital.assinarDigitalmenteDocumentoProcessoDigital(idDocumento)
	},
	async [actionTypes.PEDIDO.DOCUMENTOS.PROCESSO_DIGITAL.VALIDAR_DOCUMENTO_ASSINADO](context, idDocumento) {
		const { data } = await api.documentoPedidoProcessoDigital.validarSeDocumentoAtaFoiAssinadoNoProcessoDigital(
			idDocumento,
		)
		return data
	},
	async [actionTypes.PEDIDO.DOCUMENTOS.PROCESSO_DIGITAL.BUSCAR_DOCUMENTO_POR_ID](context, idDocumento) {
		const { data } = await api.documentoPedidoProcessoDigital.buscarPorId(idDocumento)
		return data
	},
	async [actionTypes.PEDIDO.DOCUMENTOS.PROCESSO_DIGITAL.CANCELAR_DOCUMENTO](context, payload) {
		return api.documentoPedidoProcessoDigital.cancelarDocumentoProcessoDigital(payload)
	},
}
